module.exports = __webpack_public_path__ + "mobile/img/img_btn_bg1.dc698ba6.png";